import React from 'react'
import { Link } from 'react-router-dom'
import { useAuth } from '@/hooks/useAuth'
import '@/styles/pages/error.css'

function NotFound(): React.JSX.Element {
  const { isAuthenticated } = useAuth()

  return (
    <div className="error-page">
      <div className="error-container">
        <div className="error-code">404</div>
        <h1 className="error-title">Page Not Found</h1>
        <p className="error-message">
          The page you're looking for doesn't exist. It might have been
          removed or the URL might be incorrect.
        </p>

        <div className="error-actions">
          <Link to="/" className="btn btn-primary">
            Back to Dashboard
          </Link>
          {!isAuthenticated && (
            <Link to="/login" className="btn btn-secondary">
              Go to Login
            </Link>
          )}
        </div>

        <div className="error-help">
          <p>
            Need help? <Link to="/">Contact support</Link>
          </p>
        </div>
      </div>
    </div>
  )
}

export default NotFound
